import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { applicationSelectors } from '~/selectors'

export default function useApplications() {
    const applications = useSelector(applicationSelectors.getAllApplications)
    const currAppName = useSelector(applicationSelectors.getCurrentAppName)

    const sortedApplications = useMemo(
        () =>
            applications.sort((a, b) => {
                if (a.toLowerCase() === currAppName.toLowerCase()) return -1
                if (b.toLowerCase() === currAppName.toLowerCase()) return 1
                return a.localeCompare(b)
            }),
        [applications, currAppName]
    )

    return [sortedApplications, currAppName]
}
